import { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M2.99813 0.853752C2.3308 0.473458 1.50166 0.956239 1.503 1.72432L1.53878 22.2763C1.54012 23.0442 2.37069 23.5241 3.03668 23.1418L20.9838 12.8379C21.6546 12.4529 21.653 11.4848 20.9811 11.1019L2.99813 0.853752ZM5.10368 18.5973C4.42625 18.9824 3.58825 18.479 3.60995 17.7001L3.64674 16.3795C3.65656 16.0268 3.85145 15.7055 4.15962 15.5338L9.07523 12.7949C9.75778 12.4145 9.76005 11.4335 9.07927 11.05L4.15111 8.27413C3.84156 8.09977 3.64777 7.77426 3.64202 7.41903L3.62465 6.34653C3.61212 5.57263 4.44575 5.0785 5.11866 5.46095L15.1379 11.1556C15.8124 11.539 15.8124 12.5111 15.1379 12.8944L5.10368 18.5973Z' />
        </SvgIcon>
    );
});
